import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Tatainsurancemaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.tatainsurancemaster_Id,
          sortable: true,
          cell: (row) => <span>{row.tatainsurancemaster_Id}</span>,
        },
        { name: "Text Company Code", selector: (row, i) => row.txt_company_code, sortable: true, cell: (row) => <span>{row.txt_company_code}</span>, }, { name: "Company Name", selector: (row, i) => row.companyname, sortable: true, cell: (row) => <span>{row.companyname}</span>, }, { name: "Short Name", selector: (row, i) => row.shortname, sortable: true, cell: (row) => <span>{row.shortname}</span>, }, { name: "Text Company Type", selector: (row, i) => row.txt_company_type, sortable: true, cell: (row) => <span>{row.txt_company_type}</span>, }, { name: "Corporate Customer Id", selector: (row, i) => row.corporatecustomerid, sortable: true, cell: (row) => <span>{row.corporatecustomerid}</span>, }, { name: "Number Entity Type Id", selector: (row, i) => row.num_entity_type_id, sortable: true, cell: (row) => <span>{row.num_entity_type_id}</span>, }, { name: "Tab Row Index", selector: (row, i) => row.tabrowindx, sortable: true, cell: (row) => <span>{row.tabrowindx}</span>, }, { name: "Text Status", selector: (row, i) => row.txt_status, sortable: true, cell: (row) => <span>{row.txt_status}</span>, }, { name: "Text Sap code", selector: (row, i) => row.txt_sapcode, sortable: true, cell: (row) => <span>{row.txt_sapcode}</span>, }, { name: "Text Address Line 1", selector: (row, i) => row.txt_address_line_One, sortable: true, cell: (row) => <span>{row.txt_address_line_One}</span>, }, { name: "Text Address Line 2", selector: (row, i) => row.txt_address_line_Two, sortable: true, cell: (row) => <span>{row.txt_address_line_Two}</span>, }, { name: "Text Address Line 3", selector: (row, i) => row.txt_address_line_Three, sortable: true, cell: (row) => <span>{row.txt_address_line_Three}</span>, }, { name: "Number Country Cd", selector: (row, i) => row.num_country_cd, sortable: true, cell: (row) => <span>{row.num_country_cd}</span>, }, { name: "Number State Cd", selector: (row, i) => row.num_state_cd, sortable: true, cell: (row) => <span>{row.num_state_cd}</span>, }, { name: "Number City District Cd", selector: (row, i) => row.num_citydistrict_cd, sortable: true, cell: (row) => <span>{row.num_citydistrict_cd}</span>, }, { name: "Number City Cd", selector: (row, i) => row.num_city_cd, sortable: true, cell: (row) => <span>{row.num_city_cd}</span>, }, { name: "Number Pincode", selector: (row, i) => row.num_pincode, sortable: true, cell: (row) => <span>{row.num_pincode}</span>, }, { name: "Date Start Date", selector: (row, i) => row.dat_start_date, sortable: true, cell: (row) => <span>{row.dat_start_date}</span>, }, { name: "Date End Date", selector: (row, i) => row.dat_end_date, sortable: true, cell: (row) => <span>{row.dat_end_date}</span>, }, { name: "Date Modify Date", selector: (row, i) => row.dat_modify_date, sortable: true, cell: (row) => <span>{row.dat_modify_date}</span>, }, { name: "Date Insert Date", selector: (row, i) => row.dat_insert_date, sortable: true, cell: (row) => <span>{row.dat_insert_date}</span>, }, { name: "C UId", selector: (row, i) => row.c_uid, sortable: true, cell: (row) => <span>{row.c_uid}</span>, }, { name: "C Ts", selector: (row, i) => row.c_ts, sortable: true, cell: (row) => <span>{row.c_ts}</span>, }, { name: "Last Update", selector: (row, i) => row.lastupdate, sortable: true, cell: (row) => <span>{row.lastupdate}</span>, }, { name: "U Ts", selector: (row, i) => row.u_ts, sortable: true, cell: (row) => <span>{row.u_ts}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.TatainsurancemastereditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      tatainsurancemaster_Id: "",
      txt_company_code: '', companyname: '', shortname: '', txt_company_type: '', corporatecustomerid: '', num_entity_type_id: '', tabrowindx: '', txt_status: '', txt_sapcode: '', txt_address_line_One: '', txt_address_line_Two: '', txt_address_line_Three: '', num_country_cd: '', num_state_cd: '', num_citydistrict_cd: '', num_city_cd: '', num_pincode: '', dat_start_date: '', dat_end_date: '', dat_modify_date: '', dat_insert_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'txt_company_code', inputType: 'Text', displayName: 'Text Company Code', validationOptions: { isRequired: false } },
      { fieldName: 'companyname', inputType: 'Text', displayName: 'Company Name', validationOptions: { isRequired: false } },
      { fieldName: 'shortname', inputType: 'Text', displayName: 'Short Name', validationOptions: { isRequired: false } },
      { fieldName: 'txt_company_type', inputType: 'Text', displayName: 'Text Company Type', validationOptions: { isRequired: false } },
      { fieldName: 'corporatecustomerid', inputType: 'Text', displayName: 'Corporate Customer Id', validationOptions: { isRequired: false } },
      { fieldName: 'num_entity_type_id', inputType: 'Text', displayName: 'Number Entity Type Id', validationOptions: { isRequired: false } },
      { fieldName: 'tabrowindx', inputType: 'Text', displayName: 'Tab Row Index', validationOptions: { isRequired: false } },
      { fieldName: 'txt_status', inputType: 'Text', displayName: 'Text Status', validationOptions: { isRequired: false } },
      { fieldName: 'txt_sapcode', inputType: 'Text', displayName: 'Text Sap code', validationOptions: { isRequired: false } },
      { fieldName: 'txt_address_line_One', inputType: 'Text', displayName: 'Text Address Line 1', validationOptions: { isRequired: false } },
      { fieldName: 'txt_address_line_Two', inputType: 'Text', displayName: 'Text Address Line 2', validationOptions: { isRequired: false } },
      { fieldName: 'txt_address_line_Three', inputType: 'Text', displayName: 'Text Address Line 3', validationOptions: { isRequired: false } },
      { fieldName: 'num_country_cd', inputType: 'Text', displayName: 'Number Country Cd', validationOptions: { isRequired: false } },
      { fieldName: 'num_state_cd', inputType: 'Text', displayName: 'Number State Cd', validationOptions: { isRequired: false } },
      { fieldName: 'num_citydistrict_cd', inputType: 'Text', displayName: 'Number City District Cd', validationOptions: { isRequired: false } },
      { fieldName: 'num_city_cd', inputType: 'Text', displayName: 'Number City Cd', validationOptions: { isRequired: false } },
      { fieldName: 'num_pincode', inputType: 'Text', displayName: 'Number Pincode', validationOptions: { isRequired: false } },
      { fieldName: 'dat_start_date', inputType: 'Date', displayName: 'Date Start Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_end_date', inputType: 'Date', displayName: 'Date End Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_modify_date', inputType: 'Date', displayName: 'Date Modify Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_insert_date', inputType: 'Date', displayName: 'Date Insert Date', validationOptions: { isRequired: false } },
      { fieldName: 'c_uid', inputType: 'Text', displayName: 'C UId', validationOptions: { isRequired: false } },
      { fieldName: 'c_ts', inputType: 'Text', displayName: 'C Ts', validationOptions: { isRequired: false } },
      { fieldName: 'lastupdate', inputType: 'Date', displayName: 'Last Update', validationOptions: { isRequired: false } },
      { fieldName: 'u_ts', inputType: 'Text', displayName: 'U Ts', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      txt_company_code: '', companyname: '', shortname: '', txt_company_type: '', corporatecustomerid: '', num_entity_type_id: '', tabrowindx: '', txt_status: '', txt_sapcode: '', txt_address_line_One: '', txt_address_line_Two: '', txt_address_line_Three: '', num_country_cd: '', num_state_cd: '', num_citydistrict_cd: '', num_city_cd: '', num_pincode: '', dat_start_date: '', dat_end_date: '', dat_modify_date: '', dat_insert_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      txt_company_code: '', companyname: '', shortname: '', txt_company_type: '', corporatecustomerid: '', num_entity_type_id: '', tabrowindx: '', txt_status: '', txt_sapcode: '', txt_address_line_One: '', txt_address_line_Two: '', txt_address_line_Three: '', num_country_cd: '', num_state_cd: '', num_citydistrict_cd: '', num_city_cd: '', num_pincode: '', dat_start_date: '', dat_end_date: '', dat_modify_date: '', dat_insert_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  TatainsurancemastereditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      tatainsurancemaster_Id: row.tatainsurancemaster_Id,
      txt_company_code: row.txt_company_code, companyname: row.companyname, shortname: row.shortname, txt_company_type: row.txt_company_type, corporatecustomerid: row.corporatecustomerid, num_entity_type_id: row.num_entity_type_id, tabrowindx: row.tabrowindx, txt_status: row.txt_status, txt_sapcode: row.txt_sapcode, txt_address_line_One: row.txt_address_line_One, txt_address_line_Two: row.txt_address_line_Two, txt_address_line_Three: row.txt_address_line_Three, num_country_cd: row.num_country_cd, num_state_cd: row.num_state_cd, num_citydistrict_cd: row.num_citydistrict_cd, num_city_cd: row.num_city_cd, num_pincode: row.num_pincode, dat_start_date: row.dat_start_date, dat_end_date: row.dat_end_date, dat_modify_date: row.dat_modify_date, dat_insert_date: row.dat_insert_date, c_uid: row.c_uid, c_ts: row.c_ts, lastupdate: row.lastupdate, u_ts: row.u_ts,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  TatainsurancemasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Tatainsurancemaster/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  TatainsurancemastersubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('txt_company_code', this.state.txt_company_code);
    formData.append('companyname', this.state.companyname);
    formData.append('shortname', this.state.shortname);
    formData.append('txt_company_type', this.state.txt_company_type);
    formData.append('corporatecustomerid', this.state.corporatecustomerid);
    formData.append('num_entity_type_id', this.state.num_entity_type_id);
    formData.append('tabrowindx', this.state.tabrowindx);
    formData.append('txt_status', this.state.txt_status);
    formData.append('txt_sapcode', this.state.txt_sapcode);
    formData.append('txt_address_line_One', this.state.txt_address_line_One);
    formData.append('txt_address_line_Two', this.state.txt_address_line_Two);
    formData.append('txt_address_line_Three', this.state.txt_address_line_Three);
    formData.append('num_country_cd', this.state.num_country_cd);
    formData.append('num_state_cd', this.state.num_state_cd);
    formData.append('num_citydistrict_cd', this.state.num_citydistrict_cd);
    formData.append('num_city_cd', this.state.num_city_cd);
    formData.append('num_pincode', this.state.num_pincode);
    formData.append('dat_start_date', this.state.dat_start_date);
    formData.append('dat_end_date', this.state.dat_end_date);
    formData.append('dat_modify_date', this.state.dat_modify_date);
    formData.append('dat_insert_date', this.state.dat_insert_date);
    formData.append('c_uid', this.state.c_uid);
    formData.append('c_ts', this.state.c_ts);
    formData.append('lastupdate', this.state.lastupdate);
    formData.append('u_ts', this.state.u_ts);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Tatainsurancemaster/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.TatainsurancemasterfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ txt_company_code: '', companyname: '', shortname: '', txt_company_type: '', corporatecustomerid: '', num_entity_type_id: '', tabrowindx: '', txt_status: '', txt_sapcode: '', txt_address_line_One: '', txt_address_line_Two: '', txt_address_line_Three: '', num_country_cd: '', num_state_cd: '', num_citydistrict_cd: '', num_city_cd: '', num_pincode: '', dat_start_date: '', dat_end_date: '', dat_modify_date: '', dat_insert_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  TatainsurancemasterupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tatainsurancemaster_Id", this.state.tatainsurancemaster_Id);
    formData.append('txt_company_code', this.state.txt_company_code);
    formData.append('companyname', this.state.companyname);
    formData.append('shortname', this.state.shortname);
    formData.append('txt_company_type', this.state.txt_company_type);
    formData.append('corporatecustomerid', this.state.corporatecustomerid);
    formData.append('num_entity_type_id', this.state.num_entity_type_id);
    formData.append('tabrowindx', this.state.tabrowindx);
    formData.append('txt_status', this.state.txt_status);
    formData.append('txt_sapcode', this.state.txt_sapcode);
    formData.append('txt_address_line_One', this.state.txt_address_line_One);
    formData.append('txt_address_line_Two', this.state.txt_address_line_Two);
    formData.append('txt_address_line_Three', this.state.txt_address_line_Three);
    formData.append('num_country_cd', this.state.num_country_cd);
    formData.append('num_state_cd', this.state.num_state_cd);
    formData.append('num_citydistrict_cd', this.state.num_citydistrict_cd);
    formData.append('num_city_cd', this.state.num_city_cd);
    formData.append('num_pincode', this.state.num_pincode);
    formData.append('dat_start_date', this.state.dat_start_date);
    formData.append('dat_end_date', this.state.dat_end_date);
    formData.append('dat_modify_date', this.state.dat_modify_date);
    formData.append('dat_insert_date', this.state.dat_insert_date);
    formData.append('c_uid', this.state.c_uid);
    formData.append('c_ts', this.state.c_ts);
    formData.append('lastupdate', this.state.lastupdate);
    formData.append('u_ts', this.state.u_ts);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Tatainsurancemaster/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.TatainsurancemasterfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.TatainsurancemasterfetchHandler();

    //***componentDidMount
  }

  handletxt_company_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_company_code: fieldValue });
  }; handlecompanynameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ companyname: fieldValue });
  }; handleshortnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ shortname: fieldValue });
  }; handletxt_company_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_company_type: fieldValue });
  }; handlecorporatecustomeridChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ corporatecustomerid: fieldValue });
  }; handlenum_entity_type_idChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_entity_type_id: fieldValue });
  }; handletabrowindxChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tabrowindx: fieldValue });
  }; handletxt_statusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_status: fieldValue });
  }; handletxt_sapcodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_sapcode: fieldValue });
  }; handletxt_address_line_OneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_address_line_One: fieldValue });
  }; handletxt_address_line_TwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_address_line_Two: fieldValue });
  }; handletxt_address_line_ThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_address_line_Three: fieldValue });
  }; handlenum_country_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_country_cd: fieldValue });
  }; handlenum_state_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_state_cd: fieldValue });
  }; handlenum_citydistrict_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_citydistrict_cd: fieldValue });
  }; handlenum_city_cdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_city_cd: fieldValue });
  }; handlenum_pincodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_pincode: fieldValue });
  }; handledat_start_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_start_date: fieldValue });
  }; handledat_end_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_end_date: fieldValue });
  }; handledat_modify_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_modify_date: fieldValue });
  }; handledat_insert_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_insert_date: fieldValue });
  }; handlec_uidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_uid: fieldValue });
  }; handlec_tsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_ts: fieldValue });
  }; handlelastupdateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ lastupdate: fieldValue });
  }; handleu_tsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ u_ts: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this tatainsurancemaster?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('tatainsurancemaster_Id', row.tatainsurancemaster_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Tatainsurancemaster/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.TatainsurancemasterfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>TATA Insurance Master</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Tatainsurancemaster</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Company Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_company_codeChange} className="form-control" name="txt_company_code" value={this.state.txt_company_code} required="required" placeholder="Enter Text Company Code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_company_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Company Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecompanynameChange} className="form-control" name="companyname" value={this.state.companyname} required="required" placeholder="Enter Company Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.companyname} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Short Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleshortnameChange} className="form-control" name="shortname" value={this.state.shortname} required="required" placeholder="Enter Short Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.shortname} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Company Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_company_typeChange} className="form-control" name="txt_company_type" value={this.state.txt_company_type} required="required" placeholder="Enter Text Company Type" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_company_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Corporate Customer Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecorporatecustomeridChange} className="form-control" name="corporatecustomerid" value={this.state.corporatecustomerid} required="required" placeholder="Enter Corporate Customer Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.corporatecustomerid} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Entity Type Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_entity_type_idChange} className="form-control" name="num_entity_type_id" value={this.state.num_entity_type_id} required="required" placeholder="Enter Number Entity Type Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_entity_type_id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Tab Row Index</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletabrowindxChange} className="form-control" name="tabrowindx" value={this.state.tabrowindx} required="required" placeholder="Enter Tab Row Index" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tabrowindx} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_statusChange} className="form-control" name="txt_status" value={this.state.txt_status} required="required" placeholder="Enter Text Status" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_status} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Sap code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_sapcodeChange} className="form-control" name="txt_sapcode" value={this.state.txt_sapcode} required="required" placeholder="Enter Text Sap code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_sapcode} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Address Line 1</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_address_line_OneChange} className="form-control" name="txt_address_line_One" value={this.state.txt_address_line_One} required="required" placeholder="Enter Text Address Line 1" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_address_line_One} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Address Line 2</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_address_line_TwoChange} className="form-control" name="txt_address_line_Two" value={this.state.txt_address_line_Two} required="required" placeholder="Enter Text Address Line 2" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_address_line_Two} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Address Line 3</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_address_line_ThreeChange} className="form-control" name="txt_address_line_Three" value={this.state.txt_address_line_Three} required="required" placeholder="Enter Text Address Line 3" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_address_line_Three} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Country Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_country_cdChange} className="form-control" name="num_country_cd" value={this.state.num_country_cd} required="required" placeholder="Enter Number Country Cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_country_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number State Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_state_cdChange} className="form-control" name="num_state_cd" value={this.state.num_state_cd} required="required" placeholder="Enter Number State Cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_state_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number City District Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_citydistrict_cdChange} className="form-control" name="num_citydistrict_cd" value={this.state.num_citydistrict_cd} required="required" placeholder="Enter Number City District Cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_citydistrict_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number City Cd</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_city_cdChange} className="form-control" name="num_city_cd" value={this.state.num_city_cd} required="required" placeholder="Enter Number City Cd" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_city_cd} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Pincode</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_pincodeChange} className="form-control" name="num_pincode" value={this.state.num_pincode} required="required" placeholder="Enter Number Pincode" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_pincode} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_start_dateChange} className="form-control" name="dat_start_date" value={this.state.dat_start_date} required="required" placeholder="Enter Date Start Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date End Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_end_dateChange} className="form-control" name="dat_end_date" value={this.state.dat_end_date} required="required" placeholder="Enter Date End Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Modify Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_modify_dateChange} className="form-control" name="dat_modify_date" value={this.state.dat_modify_date} required="required" placeholder="Enter Date Modify Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_modify_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_insert_dateChange} className="form-control" name="dat_insert_date" value={this.state.dat_insert_date} required="required" placeholder="Enter Date Insert Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_insert_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C UId</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_uidChange} className="form-control" name="c_uid" value={this.state.c_uid} required="required" placeholder="Enter C UId" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C Ts</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_tsChange} className="form-control" name="c_ts" value={this.state.c_ts} required="required" placeholder="Enter C Ts" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_ts} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Last Update</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handlelastupdateChange} className="form-control" name="lastupdate" value={this.state.lastupdate} required="required" placeholder="Enter Last Update" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdate} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>U Ts</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleu_tsChange} className="form-control" name="u_ts" value={this.state.u_ts} required="required" placeholder="Enter U Ts" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_ts} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.TatainsurancemastersubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Tatainsurancemaster</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Company Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_company_codeChange} className="form-control" name="txt_company_code" value={this.state.txt_company_code} required="required" placeholder="Enter Text Company Code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_company_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Company Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecompanynameChange} className="form-control" name="companyname" value={this.state.companyname} required="required" placeholder="Enter Company Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.companyname} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Short Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleshortnameChange} className="form-control" name="shortname" value={this.state.shortname} required="required" placeholder="Enter Short Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.shortname} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Company Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_company_typeChange} className="form-control" name="txt_company_type" value={this.state.txt_company_type} required="required" placeholder="Enter Text Company Type" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_company_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Corporate Customer Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecorporatecustomeridChange} className="form-control" name="corporatecustomerid" value={this.state.corporatecustomerid} required="required" placeholder="Enter Corporate Customer Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.corporatecustomerid} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Entity Type Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_entity_type_idChange} className="form-control" name="num_entity_type_id" value={this.state.num_entity_type_id} required="required" placeholder="Enter Number Entity Type Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_entity_type_id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Tab Row Index</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletabrowindxChange} className="form-control" name="tabrowindx" value={this.state.tabrowindx} required="required" placeholder="Enter Tab Row Index" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tabrowindx} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_statusChange} className="form-control" name="txt_status" value={this.state.txt_status} required="required" placeholder="Enter Text Status" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_status} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Sap code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_sapcodeChange} className="form-control" name="txt_sapcode" value={this.state.txt_sapcode} required="required" placeholder="Enter Text Sap code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_sapcode} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Address Line 1</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_address_line_OneChange} className="form-control" name="txt_address_line_One" value={this.state.txt_address_line_One} required="required" placeholder="Enter Text Address Line 1" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_address_line_One} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Address Line 2</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_address_line_TwoChange} className="form-control" name="txt_address_line_Two" value={this.state.txt_address_line_Two} required="required" placeholder="Enter Text Address Line 2" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_address_line_Two} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Address Line 3</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_address_line_ThreeChange} className="form-control" name="txt_address_line_Three" value={this.state.txt_address_line_Three} required="required" placeholder="Enter Text Address Line 3" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_address_line_Three} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Country Cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_country_cdChange} className="form-control" name="num_country_cd" value={this.state.num_country_cd} required="required" placeholder="Enter Number Country Cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_country_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number State Cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_state_cdChange} className="form-control" name="num_state_cd" value={this.state.num_state_cd} required="required" placeholder="Enter Number State Cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_state_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number City District Cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_citydistrict_cdChange} className="form-control" name="num_citydistrict_cd" value={this.state.num_citydistrict_cd} required="required" placeholder="Enter Number City District Cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_citydistrict_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number City Cd</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_city_cdChange} className="form-control" name="num_city_cd" value={this.state.num_city_cd} required="required" placeholder="Enter Number City Cd" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_city_cd} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Pincode</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_pincodeChange} className="form-control" name="num_pincode" value={this.state.num_pincode} required="required" placeholder="Enter Number Pincode" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_pincode} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_start_dateChange} className="form-control" name="dat_start_date" value={this.state.dat_start_date} required="required" placeholder="Enter Date Start Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date End Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_end_dateChange} className="form-control" name="dat_end_date" value={this.state.dat_end_date} required="required" placeholder="Enter Date End Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Modify Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_modify_dateChange} className="form-control" name="dat_modify_date" value={this.state.dat_modify_date} required="required" placeholder="Enter Date Modify Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_modify_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_insert_dateChange} className="form-control" name="dat_insert_date" value={this.state.dat_insert_date} required="required" placeholder="Enter Date Insert Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_insert_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C UId</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_uidChange} className="form-control" name="c_uid" value={this.state.c_uid} required="required" placeholder="Enter C UId" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C Ts</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_tsChange} className="form-control" name="c_ts" value={this.state.c_ts} required="required" placeholder="Enter C Ts" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_ts} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Last Update</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handlelastupdateChange} className="form-control" name="lastupdate" value={this.state.lastupdate} required="required" placeholder="Enter Last Update" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdate} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>U Ts</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleu_tsChange} className="form-control" name="u_ts" value={this.state.u_ts} required="required" placeholder="Enter U Ts" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_ts} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.TatainsurancemasterupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}